const scaleTypeOrder = [
  { value: "Contribution", label: "Contribution" },
  { value: "RATIO", label: "Ratio" },
  { value: "25", label: "25" },
  { value: "50", label: "Median" },
  { value: "75", label: "75" },
];

export const scaleTypeOptions = scaleTypeOrder;
